import React from "react";
import Icon from "./Icon";
import Bars from "./Bars";

// Centred section heading: coloured pill, title, brand bars and a lead paragraph.
const SectionIntro = ({id, pill, title, titleStyle, lead, leadMaxWidth = '54ch', style}) => (
    <section id={id} className="pb-container pb-intro" style={style}>
        <p className="pb-pill" style={{background: pill.bg, color: pill.color}}>
            {pill.icon && <Icon name={pill.icon} size={15}/>}{pill.text}
        </p>
        <h2 className="pb-intro-title" style={titleStyle}>{title}</h2>
        <div className="pb-rule"><Bars w={16} h={4} gap={4}/></div>
        <p className="pb-lead" style={{maxWidth: leadMaxWidth}}>{lead}</p>
    </section>
);

export default SectionIntro;
